import { Controller } from "@hotwired/stimulus"

// Leaves blank fields out of a GET form's URL, so a filtered list has one
// short, stable address (which lets edits redirect back to exactly it).
//
//   <form method="get" data-controller="clean-query" data-action="submit->clean-query#clean">
export default class extends Controller {
  clean() {
    for (const field of this.element.elements) {
      if (field.name && field.value === "" && !field.disabled) {
        field.disabled = true
        // Re-enable after the browser has read the form, so the page keeps working.
        setTimeout(() => { field.disabled = false }, 0)
      }
    }
  }
}
